const BASE = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:4000/api';

async function req(method, path, body, token) {
  const res = await fetch(BASE + path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: 'Bearer ' + token } : {})
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });
  const ctype = res.headers.get('content-type') || '';
  if (!ctype.includes('application/json')) {
    const raw = await res.text().catch(() => '');
    const preview = raw.replace(/\s+/g, ' ').slice(0, 300);
    const hcdnId = res.headers.get('x-hcdn-request-id') || '';
    console.error(`[api] ${method} ${path} respuesta no-JSON status=${res.status} contentType="${ctype}" hcdnId="${hcdnId}" preview="${preview}"`);
    if (res.status === 405) throw new Error('Petición rechazada por el proxy (405). Prueba en modo incógnito o avisa al admin con el ID: ' + hcdnId);
    if (res.status === 413) throw new Error('La proforma es demasiado grande para guardarse (intenta reducir el logo de empresa)');
    if (res.status === 502 || res.status === 504) throw new Error(`Servidor no disponible (${res.status}). Reintenta en unos segundos.`);
    throw new Error(`Respuesta inesperada del servidor (${res.status}). ${preview ? 'Inicio: ' + preview.slice(0, 80) : ''}`);
  }
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.error || 'Error del servidor');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Origen del backend para construir URLs de archivos servidos (raw). '' en prod (mismo host).
export const API_ORIGIN = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:4000';

// Subida multipart (FormData). No fija Content-Type: el navegador pone el boundary.
export async function apiUpload(path, formData, token) {
  const res = await fetch(BASE + path, {
    method: 'POST',
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) { const err = new Error(data.error || 'Error al subir el archivo'); err.status = res.status; throw err; }
  return data;
}

export const apiGet    = (path, token)        => req('GET',    path, undefined, token);
export const apiPost   = (path, body, token)  => req('POST',   path, body,      token);
export const apiPut    = (path, body, token)  => req('PUT',    path, body,      token);
export const apiPatch  = (path, body, token)  => req('PATCH',  path, body,      token);
export const apiDelete = (path, token)        => req('DELETE', path, undefined, token);
